import * as yup from "yup";

import { ContactTypeEnum } from "../enum/WaybillNofitications.enum";
import { Searches } from "Models/shipeezi.table";

export const validationSchema = yup.object().shape({
  contactType: yup.string().required("Type of contact is required"),
  jobReference: yup.string().required("Order is required"),
  firstName: yup.string().required("First name is required"),
  lastName: yup.string(),
  email: yup
    .string()
    .email("Invalid email format")
    .when("notifyViaEmail", {
      is: true,
      then: (schema) => schema.required("Email is required"),
      otherwise: (schema) => schema,
    }),
  mobile: yup.string().when("notifyViaSms", {
    is: true,
    then: (schema) => schema.required("Mobile number is required"),
    otherwise: (schema) => schema,
  }),
  notifyViaEmail: yup.boolean(),
  notifyViaSms: yup.boolean(),
});

export const convertValueToSearch = (value: string, column: string) => {
  return [
    {
      [column]: value,
    },
  ] as Searches;
};
